import { LiveStream } from 'types/stream';
import { useSelector } from 'react-redux';
import { hostedVideoSelectors } from '../../../../store/modules/hostedVideo';

const defaultSizes = {
  width: 1920,
  height: 1080
};

const useVideoSizes = (stream: LiveStream) => {
  const videoData = useSelector(hostedVideoSelectors.selectVideoData);

  const sizes = {
    width: stream.meta.width || videoData?.sizes.width || defaultSizes.width,
    height: stream.meta.height || videoData?.sizes.height || defaultSizes.height
  };

  return sizes;
};

export default useVideoSizes;
